// *** Create Post Component ****
import React, { useEffect, useState } from "react";
import user from "../../assets/img/user 1.svg";
import {
  savePost, editPost,
} from "../../services/apiPosts";
import "../../assets/css/text-limit.css";
import {checkCharacterLimit}  from "../../utils/textLimiter";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
const CreateDiscussion = (props) => {
    const MAX_POST_LENGTH = 4000;
  const [characterLimit, setCharacterLimit] = useState({
    isOverLimit: false,
    remaining: MAX_POST_LENGTH,
    limitedText: ''
  });
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    const limitInfo = checkCharacterLimit(inputValue, MAX_POST_LENGTH);
    setCharacterLimit(limitInfo);
  }, [inputValue]);
  const[isSucess,SetSucess]=useState(false);
  const[ResponseMessage,SetResponseMessage]=useState("");

  const handleSavePost = async (event) => {

    if (!inputValue.trim()) {

      return;
    }
    if (characterLimit.isOverLimit) {
     
      alert(`Post exceeds maximum length of ${MAX_POST_LENGTH} characters`);
      return;
    }

     
    let response = await savePost({ userid: userData._id, post: inputValue, organizationid: props.Organiationid });
    if (response.status === true) {
      setInputValue("");
      if (props.source === "profile")
        props.fetchAllFeeds({ userid: userData._id, offset: 0, limit: 10 });
      else
        props.fetchAllDiscussions({ userid: userData._id, organizationid: props.Organiationid, offset: 0, limit: 20 });

    }
    else{
          SetSucess(true);
         SetResponseMessage(response.message);

    }



  };


  return (
    <div>
          <div className="create-post-section">
              <img src={user} className="create-post-avtar " />
             <input type="text" className="createpost-wrp" placeholder="Create Discussion"value={inputValue} maxLength={MAX_POST_LENGTH}
        onChange={(e) => setInputValue(e.target.value)} onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSavePost(); // Call your save function here
          }
        }}></input> 

        

            </div>

      <div className={`character-counter ${characterLimit.isOverLimit ? 'text-danger' : 'text-muted'}`}>
          {characterLimit.remaining ?? MAX_POST_LENGTH} characters remaining
          {characterLimit.remaining <= 0  && (
            <span className="limit-warning"> (Maximum limit reached)</span>
          )}
        </div>
         {isSucess && (<ResponsePopup 
                              isSucess={isSucess} 
                              CancelPopup={() => { 
                               SetSucess(false);
                              }} 
                              message={ResponseMessage}
                            />)}
    </div>
  );
};
export default CreateDiscussion;